import frontUrl from '../modules/front/url';

import adminDashboard from '../modules/admin/dashboard';
import adminDataSources from '../modules/admin/dataSources';
import adminNavigation from '../modules/admin/navigation';
import adminProfiles from '../modules/admin/profiles';


export default function (html, target) {
	switch (target) {
		case 'front_url':
			frontUrl(html)
			break

		case 'admin_dashboard':
			adminDashboard(html)
			break

		case 'admin_dataSources':
			adminDataSources(html)
			break

		case 'admin_addArticle':
		case 'admin_editArticle':
			break

		case 'admin_addPage':
		case 'admin_editPage':
			break

		case 'admin_addProfile':
		case 'admin_editProfile':
			break

		case 'admin_editNavigation':
			adminNavigation(html)
			break

		case 'admin_profiles':
			adminProfiles(html)
			break

		default:
			console.error('Module scope cannot be loaded: ' + target)
	}
}
